import React from 'react';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import useColumns from './columns';

const Customers = () => {
  const columns = useColumns();

  return (
    <SimpleResourceLandingLayout
      resourceName="customers"
      withSubRoutes
      columns={columns}
      withUploadButton={false}
      withCreateButton={false}
      deleteAction={false}
    />
  );
};

export default Customers;
